import React, { useCallback, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import {
    Stashboard,
    useSpringBigStore,
    useStashboards,
    useAppSettings,
    Member,
    StashboardKey,
    handleDate,
} from '@springbig/shared';
import MessageCarousel from './components/MessagesCarousel';
import { useAuthorization } from '~/hooks/auth';
import { orderBy } from 'lodash';
import { NoDataPlaceholder } from '~/shared/NoDataPlaceholder';
import { faMessage } from '@fortawesome/free-solid-svg-icons';
import { Section } from '~/shared/Theme';
import { MessagesSkeleton } from './components/MessagesSkeleton';

dayjs.extend(relativeTime);

const filterStashboard = (
    member: Member | null | undefined,
    stashboards: Stashboard[] | undefined,
    stashboardKeys: StashboardKey[] | undefined,
    expirationDateInDays: number | undefined
) => {

    if (!stashboards || !stashboards?.length) {
        return;
    }

    const filtered = stashboards.filter(item => (

        Number(item.merchant_id) === Number(member?.merchant_id)
    ));

    const alreadyFetched = filtered?.map((k) => k._key);
    const oldKeys = stashboardKeys?.filter((k) => alreadyFetched?.includes(k.stashboard_key));
    const validStashboardKeys = oldKeys?.filter((key) => !!handleDate(expirationDateInDays, key.epoch));
    const _stashboards = stashboards?.filter((s) => validStashboardKeys?.map((k) => k.stashboard_key).includes(s._key));
    return orderBy(_stashboards,
        ['sent_at'],
        ['desc']);
};

const MessageListScreen = () => {

    const [items, setItems] = useState<Stashboard[]>([]);
    const { fetch, isLoading } = useStashboards();
    const { isLoadingAuth } = useAuthorization();
    const { member, stashboards, stashboardKeys } = useSpringBigStore();
    const {
        expirationDateInDays
    } = useAppSettings();

    const fetchData = useCallback(() => {
        if (!member?.id) {
            return;
        }

        fetch();
    }, [member?.id]);

    useEffect(() => {

        if (member?.id) {
            fetchData();
        }
    }, [fetchData]);

    useEffect(() => {

        if (!isLoading && stashboards && stashboards.length > 0) {
            const filteredStashboard = filterStashboard(member, stashboards, stashboardKeys, expirationDateInDays);
            filteredStashboard && setItems(filteredStashboard);
        }
    }, [isLoading, stashboards]);

    const isInitialLoading = isLoading || isLoadingAuth || (!member || !stashboards || (stashboards.length > 0 && !(items && items.length > 0)));
    const noItemsAvailable = (!items || !(items && items.length > 0) ) && member && !(isLoading || isLoadingAuth);

    if (isInitialLoading) {
        return <MessagesSkeleton />;
    }

    if (noItemsAvailable) {
        return (
            <Section>
                <NoDataPlaceholder
                    title={'common.messages_placeholder_title'}
                    message={'common.messages_placeholder_subtitle'}
                    callback={fetch}
                    isLoading={isLoading}
                    iconName={faMessage}
                />
            </Section>
        );
    }

    return (
        <Section display={'block'}>

            {items.length > 0 && items.map((data) => {

                return (
                    <MessageCarousel
                        key={`${data._key}-stashboard`}
                        data={data}
                        hasMoreContent
                    />
                );
            })
            }
        </Section>
    );
};

export default MessageListScreen;
